import React, { useState } from 'react';
import './VolunteerForm.css';
import MyFooter from './MyFooter';
import { useLanguage } from '../context/LanguageContext';


const VolunteerForm = () => {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    skills: '',
    reason: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/volunteers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitMessage(language === 'en' ? 'Thank you for your application! We will contact you soon.' : 'അപ്ലിക്കേഷൻ നൽകിയതിന് നന്ദി! ഞങ്ങള്‍ നിങ്ങളോട് ബന്ധപ്പെടും.');
        // Reset form
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          mobile: '',
          skills: '',
          reason: '',
        });
      } else {
        setSubmitMessage(data.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitMessage('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Banner Section */}
      <div className="volunteer-banner">
        <div className="banner-overlay">
          <h1>{language === 'en' ? 'Join Our Volunteer Team' : 'ഞങ്ങളുടെ സന്നദ്ധ സേവന സംഘത്തിൽ ചേരൂ'}</h1>
          <p>{language === 'en' ? 'Make a difference in your community today' : 'നിങ്ങളുടെ സമൂഹത്തിൽ വ്യത്യസ്തത വരുത്തൂ'}</p>
        </div>
      </div>
      
      <div data-aos="fade-up" className="info-section">
        {/* Information Section with Photo */}
        <div className="info-text">
          <h2>{language === 'en' ? 'Become a Palliative Community Volunteer' : 'പാലിയേറ്റീവ് കമ്മ്യൂണിറ്റി വളണ്ടിയറാവുക'}</h2>
          <p>
            {language === 'en' ? 'If you can spare a little time to listen and support those in your local community who are bedridden, suffering from serious illnesses, or facing other challenges, you can make a difference as a Palliative Community Volunteer!' : 'നിങ്ങളുടെ പ്രാദേശിക സമൂഹത്തിൽ കിടപ്പിലായവർക്കും, ഗുരുതരമായ രോഗങ്ങളാൽ ബുദ്ധിമുട്ടുന്നവർക്കും, മറ്റ് വെല്ലുവിളികൾ നേരിടുന്നവർക്കും ചെവികൊടുക്കാനും പിന്തുണ നൽകാനും അല്പസമയം മാറ്റിവെക്കാൻ നിങ്ങൾക്ക് കഴിയുമെങ്കിൽ, ഒരു പാലിയേറ്റീവ് കമ്മ്യൂണിറ്റി വോളന്റിയർ എന്ന നിലയിൽ നിങ്ങൾക്ക് മാറ്റമുണ്ടാക്കാൻ കഴിയും!'}
          </p>
          <p>
            {language === 'en' ? 'No matter your background—education, profession, gender, religion, or political views—if you\'re committed to helping the marginalised, we\'d love to hear from you.' : 'നിങ്ങളുടെ പശ്ചാത്തലം എന്തുതന്നെയായാലും—വിദ്യാഭ്യാസം, തൊഴിൽ, ലിംഗം, മതം, അല്ലെങ്കിൽ രാഷ്ട്രീയ അഭിപ്രായങ്ങൾ എന്നിവ പരിഗണിക്കാതെ—അരികുവൽക്കരിക്കപ്പെട്ടവരെ സഹായിക്കാൻ നിങ്ങൾ പ്രതിജ്ഞാബദ്ധരാണെങ്കിൽ, നിങ്ങളിൽ നിന്ന് കേൾക്കാൻ ഞങ്ങൾ ആഗ്രഹിക്കുന്നു.'}
          </p>
          <h3>{language === 'en' ? 'Current Volunteer Opportunities:' : 'നിലവിലുള്ള സന്നദ്ധ സേവന(വളണ്ടിയർ) അവസരങ്ങൾ: '}</h3>
          <ul>
            <li>Community outreach programs</li>
            <li>Event planning and coordination</li>
            <li>Fundraising and donor relations</li>
            <li>Administrative support</li>
            <li>Specialized skills (graphic design, web development, etc.)</li>
          </ul>
        </div>
        <div data-aos="slide-left" data-aos-duration="1000" className="info-photo">
          <img src="../images/vol-img.jpg" alt="Volume" />
        </div>
      </div>

      <div data-aos="fade-up" className="volunteer-form-container">
        {/* Volunteer Form */}
        <form onSubmit={handleSubmit} className="volunteer-form">
          <h2>{language === 'en' ? 'Get Involved Today' : 'ഇന്ന് തന്നെ പങ്കാളിയാകൂ'}</h2>
          <p>{language === 'en' ? 'Contact us to learn how you can support those in need.' : 'നിങ്ങൾക്ക് എങ്ങനെ സഹായിക്കാൻ കഴിയുന്നുവെന്ന് ഞങ്ങളോട് ബന്ധപ്പെടുക'}</p>

          {submitMessage && (
            <div className={`submit-message ${submitMessage.includes('Thank you') ? 'success' : 'error'}`}>
              {submitMessage}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="first_name">First Name<span className='text-danger'>*</span></label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="last_name">Last Name<span className='text-danger'>*</span></label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email<span className='text-danger'>*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="mobile">Phone Number<span className='text-danger'>*</span></label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="skills">{language === 'en' ? 'Skills/Areas of Interest' : 'കഴിവുകൾ / താത്പര്യമുള്ള മേഖലകൾ'}</label>
            <textarea
              id="skills"
              name="skills"
              value={formData.skills}
              onChange={handleChange}
              placeholder="Please list any skills or areas you're particularly interested in"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="reason">{language === 'en' ? 'Why do you want to volunteer with us?' : 'ഞങ്ങളുടെ കൂടെ സേവനം ചെയ്യാൻ ആഗ്രഹിക്കുന്നത് എന്തുകൊണ്ടാണ്?'}<span className='text-danger'>*</span></label>
            <textarea
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              required
              placeholder="Please tell us what motivates you to join our team (200 words max)"
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-btn2"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : language === 'en' ? 'Submit Application' : 'അപ്ലിക്കേഷൻ സമർപ്പിക്കുക'}
          </button>
        </form>
      </div>
    </>
  );
};

export default VolunteerForm;